<!-- Modalbox: export -->
<p-dialog [(visible)]="visible" (onHide)="onCancel()" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false"
  [header]="'EXPORT_SETTINGS.TITLE' | translate">
  <form [formGroup]="exportFormGroup">
    <div class="row">
      <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-4">
        <label data-testid="export-label-name" class="block text-sm mb-1" for="exportName">{{ 'EXPORT_SETTINGS.LABEL_NAME' | translate }}</label>
        <div class="input-clear-wr">
          <input data-testid="export-name-input" type="text" formControlName="exportName" autocomplete="off" class="text-field" placeholder="{{ 'EXPORT_SETTINGS.PLACEHOLDER_NAME' | translate }}">
          @if (exportFormGroup.get('exportName')?.value) {
            <button type="button" class="clear-btn" (click)="exportFormGroup.get('exportName')?.setValue('')">
              <span class="clear-icon"></span>
            </button>
          }
        </div>
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-4">
        <label data-testid="export-label-daterange" class="block text-sm mb-1" for="exportDateRange">{{ 'EXPORT_SETTINGS.LABEL_DATE_RANGE' | translate
          }} <i class="icon-required-field"></i></label>
          <p-datepicker data-testid="export-daterange-input" formControlName="dateRange" selectionMode="range" [readonlyInput]="true"
            dateFormat="dd-mm-yy" [maxDate]="currentDate" showIcon="true" [showTime]="false" appendTo="body"
            placeholder="{{ 'EXPORT_SETTINGS.PLACEHOLDER_DATE_RANGE' | translate }}" class="p-datepicker w-full" />
        </div>
        <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-4">
          <label class="block text-sm mb-4">{{ 'EXPORT_SETTINGS.LABEL_FORMAT' | translate }}</label>
          <span data-testid="export-format-csv" class="inline-flex mr-6">
            <p-radioButton name="format" inputId="csv" value="CSV" formControlName="format" />
            <label for="csv" class="ml-2">{{ 'EXPORT_SETTINGS.OPTION_CSV' | translate }}</label>
          </span>
          <span data-testid="export-format-xlsx" class="inline-flex mr-2">
            <p-radioButton name="format" inputId="xls" value="XLSX" formControlName="format" />
            <label for="xls" class="ml-2">{{ 'EXPORT_SETTINGS.OPTION_XLS' | translate }}</label>
          </span>
        </div>
      </div>
    </form>
    <ng-template #footer>
      <button data-testid="export-cancel-btn" type="button" class="btn outline-btn" (click)="onCancel()">{{ 'EXPORT_SETTINGS.BTN_CANCEL' | translate
      }}</button>
      <button data-testid="export-btn" type="button" class="btn primary-btn" (click)="onExport()" [disabled]="exportFormGroup.invalid">
        {{ 'EXPORT_SETTINGS.BTN_EXPORT' | translate }}
      </button>
    </ng-template>
  </p-dialog>
